// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/modern/" + {"141":"contacts-page","195":"account-page","234":"index-page","328":"focus-visible","353":"imask","390":"swiper","680":"trial-page"}[chunkId] + "." + {"141":"69f41a0d","195":"808984da","234":"0e64d91c","328":"6ee8c859","353":"c31cbdb1","390":"670cd387","680":"4dd88d9e"}[chunkId] + ".js";
};